import React from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import { getId } from '../../../api/Layers/layer-operations';
import GraphicsCollection from '../../../api/Graphics/Graphics';
import ModalElementGraphics from '../ModalElementGraphics';
import ViewGraphicsComponent from '../ViewGraphicsComponent';
import useTimeStore from '../ZustandProvider';

const GraphicsComponent = props => {
  const { graphicList, MapProps, layer, loading } = props;
  const drawerWidth = useTimeStore(state => state.drawerWidth);
  const [indexGraphic, setIndexGraphic] = React.useState(0);
  const [oldLayerId, setOldLayerId] = React.useState('');
  const [modal, setModal] = React.useState(false);

  const cambiarIndice = prop => {
    setOldLayerId(layer._id);
    if (prop === 'restar') {
      if (indexGraphic !== 0) {
        setIndexGraphic(indexGraphic - 1);
      }
    } else if (indexGraphic !== graphicList.length - 1) {
      setIndexGraphic(indexGraphic + 1);
    }
  };

  const indexGraphicFunction = () => {
    if (layer._id === oldLayerId) {
      return indexGraphic;
    }
    return 0;
  };

  return (
    <>
      {!loading && !isEmpty(graphicList) ? (
        <Box>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <IconButton onClick={() => cambiarIndice('restar')}>
                <KeyboardArrowLeftIcon />
              </IconButton>
            </Grid>
            <Grid item xs={6}>
              <div className="row" style={{ alignItems: 'baseline', display: 'inline-flex' }}>
                <h1 style={{ marginRight: '15px' }}>{graphicList[indexGraphicFunction()].name}</h1>
                <h4>
                  {indexGraphic + 1}/{graphicList.length}
                </h4>
              </div>
            </Grid>
            <Grid item xs={3}>
              <IconButton onClick={() => cambiarIndice('sumar')}>
                <KeyboardArrowRightIcon />
              </IconButton>
              <IconButton onClick={() => setModal(true)}>
                <ZoomOutMapIcon />
              </IconButton>
            </Grid>
          </Grid>
          {modal === false && (
            <ViewGraphicsComponent
              aspectRatio={drawerWidth / 25}
              history={MapProps.history}
              layerId={layer._id}
              graphicId={graphicList[indexGraphicFunction()]._id}
              modal={false}
            />
          )}
        </Box>
      ) : (
        <h4>Esta layer no contiene ningún gráfico</h4>
      )}
      <ModalElementGraphics
        modalShow={modal}
        onHide={() => setModal(false)}
        indexGraphic={indexGraphic}
        {...props}
      />
    </>
  );
};

GraphicsComponent.defaultProps = {
  graphicList: [],
  layer: {},
  loading: true,
  MapProps: {}
};

GraphicsComponent.propTypes = {
  graphicList: PropTypes.array,
  layer: PropTypes.object,
  loading: PropTypes.bool,
  MapProps: PropTypes.object
};

export default withTracker(({ layer, MapProps }) => {
  const graphicQuery = () => {
    if (MapProps.map.shared === true) {
      const graphicQueryAux = { deleted: { $eq: 'no' }, layerId: getId(layer), shared: true };
      return graphicQueryAux;
    }
    if (MapProps.map.sharedPrivate === true) {
      const graphicQueryAux = {
        deleted: { $eq: 'no' },
        layerId: getId(layer),
        sharedPrivate: true
      };

      return graphicQueryAux;
    }
    const graphicQueryAux = {
      deleted: { $eq: 'no' },
      layerId: getId(layer)
    };
    return graphicQueryAux;
  };
  const graphicsSub = Meteor.subscribe('graphics');
  const sort = { updatedAt: -1 };
  const sortOptions = { sort };

  return {
    graphicList: GraphicsCollection.find(graphicQuery(), sortOptions).fetch(),
    loading: !graphicsSub.ready()
  };
})(GraphicsComponent);
